import React, {useState} from "react";
import User from "./User";
import UserProfile from "./UserProfile";

function UserList({userIDs}){
    const [userID, setUserID] = useState(1);
    let ids = [...Array(50).keys()].map(x => x+1);

    const openProfile = (id) => {
        setUserID(id);
    }

    return (
        <div id="main">
            <div id="userList">
                {
                    ids.map((id, index) => {
                        return (
                            <User key={index} userID={id} onClick={openProfile}/>
                        )
                    })
                }
            </div>
            <UserProfile userID={userID}/>
        </div>
    )
}

export default UserList;